import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-amenities',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="surface-card rounded-3xl p-6 md:p-8 antialiased"
    >
      <div class="flex items-center gap-2 mb-6 pb-2 border-b border-border-subtle">
        <div class="w-1.5 h-3.5 bg-primary rounded-sm shadow-sm"></div>
        <h2 class="text-sm font-black text-text-primary uppercase tracking-wider font-mono">
          {{ 'projectsDetails.amenitiesTitle' | translate }}
        </h2>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        @for (amenity of amenities; track amenity) {
          <div
            class="group flex items-center gap-3 p-3 bg-surface-elevated/40 border border-border hover:border-border-primary rounded-2xl hover:bg-surface-elevated hover:shadow-subtle transition-all duration-200"
          >
            <div
              class="w-8 h-8 rounded-xl bg-surface border border-border shadow-sm flex items-center justify-center text-text-muted group-hover:text-primary group-hover:border-primary/30 transition-colors shrink-0"
            >
              <i [class]="getAmenityIcon(amenity)" class="text-xs"></i>
            </div>

            <span
              class="text-xs font-semibold text-text-secondary group-hover:text-text-primary transition-colors tracking-tight"
            >
              {{ amenity }}
            </span>
          </div>
        }
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class AmenitiesComponent {
  @Input() amenities: string[] = [];

  getAmenityIcon(amenity: string): string {
    const text = amenity.toLowerCase();

    if (text.includes('pool') || text.includes('swim') || text.includes('water')) {
      return 'fa-solid fa-person-swimming';
    }
    if (text.includes('gym') || text.includes('fitness') || text.includes('equipped')) {
      return 'fa-solid fa-dumbbell';
    }
    if (text.includes('commercial') || text.includes('mall') || text.includes('shop')) {
      return 'fa-solid fa-bag-shopping';
    }
    if (text.includes('nursery') || text.includes('school') || text.includes('kids')) {
      return 'fa-solid fa-graduation-cap';
    }
    if (text.includes('track') || text.includes('run') || text.includes('cycl')) {
      return 'fa-solid fa-person-running';
    }
    if (text.includes('garden') || text.includes('green') || text.includes('park')) {
      return 'fa-solid fa-tree';
    }
    if (text.includes('security') || text.includes('guard') || text.includes('24/7')) {
      return 'fa-solid fa-shield-halved';
    }
    if (text.includes('parking') || text.includes('car') || text.includes('garage')) {
      return 'fa-solid fa-square-parking';
    }
    if (text.includes('spa') || text.includes('jacuzzi')) {
      return 'fa-solid fa-spa';
    }
    if (text.includes('medical') || text.includes('clinic') || text.includes('health')) {
      return 'fa-solid fa-house-medical';
    }

    return 'fa-solid fa-sparkles';
  }
}
